/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function SpecialSpec(props) {
	const { t } = useTranslation();

	return (
		<BasicCrudScreenType
			id={"SpecialSpec"}
			headerTitle={t("term.specialSpec")}
			table={"SpecialSpec"}
			view={"VwSpecialSpec"}
			buttonsInFrontOfSearch
		/>
	);
}

export default SpecialSpec;
